import React, { useState, useEffect } from "react";
import styles from "../EventList/LeftSideEventInfo.module.css";
// import Icon from "@material-ui/core/Icon";
// import Place from "@material-ui/icons/Place";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/it";

moment.locale("it");
const MAX_TEXT_LENGTH = 190;

function checkColor(color) {
  var c = color.substring(1); // strip #
  var rgb = parseInt(c, 16); // convert rrggbb to decimal
  var r = (rgb >> 16) & 0xff; // extract red
  var g = (rgb >> 8) & 0xff; // extract green
  var b = (rgb >> 0) & 0xff; // extract blue
  var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709
  if (luma < 100) {
    return "white";
  } else {
    return "#303030";
  }
}

// eslint-disable-next-line
const LeftSideMuseumInfoTickets = ({ museum }) => {
  // console.log("museum verooooooo", museum);
  const { t } = useTranslation();
  const [descriptionToShow, setDescriptionToShow] = useState(
    // eslint-disable-next-line
    museum?.descrizione_museo?.substring(0, MAX_TEXT_LENGTH)
  );

  useEffect(() => {
    if (museum && museum.descrizione_museo) {
      setDescriptionToShow(
        museum.descrizione_museo.substring(0, MAX_TEXT_LENGTH)
      );
    }
  }, [museum]);

  const [showMoreActive, setShowMoreActive] = useState(false);

  const onShowMorePress = () => {
    setShowMoreActive(true);
    // eslint-disable-next-line
    setDescriptionToShow(museum?.descrizione_museo);
  };

  const onShowLessPress = () => {
    setShowMoreActive(false);
    setDescriptionToShow(
      // eslint-disable-next-line
      museum?.descrizione_museo?.substring(0, MAX_TEXT_LENGTH)
    );
  };

  return (
    <div
      className={styles.container}
      style={{
        // eslint-disable-next-line
        backgroundColor: museum?.colore || "#303030",
        // eslint-disable-next-line
        color: museum?.colore ? checkColor(museum?.colore) : "#303030",
      }}
    >
      {/* eslint-disable-next-line */}
      <h2 className={styles.eventTitle}>{museum?.nome}</h2>
      <div className={styles.eventInfo}>
        {/*<Icon
          key="place"
          aria-label="Place"
          color="inherit"
          style={{ marginRight: "8px" }}
        >
          <Place />
        </Icon>*/}
        <h3>{t("location")}</h3>
        {/* eslint-disable-next-line */}
        <p>{museum?.indirizzo_museo}</p>
      </div>

      {descriptionToShow && descriptionToShow.length > 0 && (
        <div className={styles.eventInfoColumn}>
          <h3>{t("information")}</h3>
          <p>
            {descriptionToShow}
            {/* eslint-disable-next-line */}
            {descriptionToShow?.length < museum?.descrizione_museo?.length &&
              " ..."}
          </p>

          {/* eslint-disable-next-line */}
          {descriptionToShow?.length < museum?.descrizione_museo?.length &&
            !showMoreActive && (
              <div className={styles.showMore} onClick={onShowMorePress}>
                <ExpandMoreIcon />
                <p>{t("readMore")}</p>
              </div>
            )}

          {showMoreActive && (
            <div className={styles.showMore} onClick={onShowLessPress}>
              <ExpandLessIcon />
              <p>{t("readLess")}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LeftSideMuseumInfoTickets;
